import {SiteBasics as SiteBasics} from 'Common/SiteBasics';
import Assert from 'Common/Assert';
import {ArtistRoutes as ArtistRoutes} from 'Common/artists/ArtistRoutes';
import {ConfigFactoryCreator} from 'Shared/config/ConfigFactoryCreator';
import {IVenueConfig} from 'Shared/config/IVenueConfig';
import {RoutesType} from 'Shared/Routes';
import {SiteType} from 'Common/SiteType';


export function selectRoutes(site:SiteBasics)
{
	switch(site.type) {
		case SiteType.venue:	
			const config = <IVenueConfig> (new ConfigFactoryCreator()).create(site.key);
			return <RoutesType> config.routes();

		case SiteType.artist:
			return <RoutesType> (new ArtistRoutes()).routes();
	}
	Assert.check(false);
}

